import { useTheme } from "@mui/material";
const useThemeColor = (color) => {
  const theme = useTheme();
  return getThemeColor(theme, color);
};
const getThemeColor = (theme, color) => {
  const isCommonColor = color == null ? void 0 : color.startsWith("common.");
  return isCommonColor ? theme.palette.common[color.split(".")[1]] : theme.palette[color].main;
};
export {
  getThemeColor,
  useThemeColor
};
//# sourceMappingURL=useThemeColor.es.js.map
